import { CriticZone } from '../interfaces/critic-zone';
import { buildMapInfoWindow } from './map-info-window';

/**
 * Globo de una zona crítica. Vive en core porque standard-map y routes-map lo pintan igual;
 * antes era el mismo método duplicado en los dos componentes.
 */
export function buildCriticZoneInfoWindow(zone: CriticZone, type: 'start' | 'end'): string {
  const point = type === 'start' ? zone.start : zone.end;
  const name = point && point.alias ? point.alias : (point && point.name ? point.name : '');
  return buildMapInfoWindow({
    icon: 'fas fa-exclamation-triangle',
    title: zone.name ? zone.name : 'Zona crítica',
    subtitle: type === 'start' ? 'Inicio de la zona' : 'Fin de la zona',
    rows: [
      { label: type === 'start' ? 'Inicio' : 'Fin', value: name },
      { label: 'Motivo', value: zone.reason }
    ]
  });
}
